import React from 'react';
import { Card } from '@/components/ui/card';
import { ROLE_LABELS } from '@/lib/constants';
import { CalendarClock } from 'lucide-react';

export default function NvBalance({ stats }) {
  const rows = stats?.nv_balance || [];
  if (!rows.length) return null;
  const totalRemaining = stats.nv_total_remaining || 0;
  const weekendById = {};
  (stats.weekend_balance || []).forEach((w) => { weekendById[w.id] = w.this_month; });

  return (
    <Card className="p-4" data-testid="nv-balance-card">
      <div className="flex items-center gap-2 mb-3">
        <CalendarClock className="w-4 h-4 text-slate-500" />
        <h3 className="text-sm font-semibold text-slate-700">Bilancia náhradného voľna (NV) – §93</h3>
        <span
          data-testid="nv-total-remaining"
          className={`ml-auto text-xs font-mono px-2 py-1 rounded-md border ${totalRemaining > 0 ? 'bg-amber-100 text-amber-800 border-amber-200' : 'bg-green-100 text-green-800 border-green-200'}`}
        >
          Zostatok spolu: {totalRemaining} dní
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs" data-testid="nv-balance-table">
          <thead>
            <tr className="text-slate-400 text-left border-b border-slate-100">
              <th className="pb-1.5 font-medium">Zamestnanec</th>
              <th className="pb-1.5 font-medium text-right" title="Zostatok NV prenesený z predchádzajúcich mesiacov">Prenos</th>
              <th className="pb-1.5 font-medium text-center" title="Odpracované víkendové dni / z toho nahradené (NV poskytnuté)">Odpracované / Nahradené</th>
              <th className="pb-1.5 font-medium text-right" title="Zostáva nahradiť – čerpá sa FIFO (najstaršie prvé), prenáša sa ďalej">Zostatok</th>
              <th className="pb-1.5 font-medium text-right" title="Vek najstaršieho nevyčerpaného NV (mesiace). Lehota 4–8 mes. podľa režimu §93.">Vek dlhu</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const worked = weekendById[r.id] ?? r.earned;
              const age = r.oldest_age || 0;
              return (
                <tr key={r.id} data-testid={`nv-row-${r.id}`} className="border-b border-slate-50 last:border-0">
                  <td className="py-1.5">
                    <div className="font-medium text-slate-700">{r.name}</div>
                    <div className="text-[10px] text-slate-400">{ROLE_LABELS[r.role] || r.role}</div>
                  </td>
                  <td className="py-1.5 text-right font-mono text-slate-500">{r.carry_in || 0}</td>
                  <td className="py-1.5 text-center font-mono">
                    <span className="text-slate-700 font-semibold">{worked}</span>
                    <span className="text-slate-300"> / </span>
                    <span className="text-green-700 font-semibold">{r.taken}</span>
                  </td>
                  <td className={`py-1.5 text-right font-mono font-bold ${r.remaining > 0 ? 'text-amber-600' : 'text-slate-400'}`}>{r.remaining}</td>
                  <td className={`py-1.5 text-right font-mono ${age >= 4 ? 'text-red-600 font-bold' : age > 0 ? 'text-amber-600' : 'text-slate-300'}`} data-testid={`nv-age-${r.id}`}>
                    {r.remaining > 0 ? `${age} m${age >= 4 ? ' ⚠' : ''}` : '–'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="text-[11px] text-slate-400 mt-3 leading-relaxed">
        Formát „Odpracované / Nahradené" = odpracované víkendové dni / z toho už poskytnuté náhradné voľno. NV vzniká len pri víkende bez 35h nepretržitého odpočinku s voľnou nedeľou. <strong>Zostatok</strong> sa čerpá metódou FIFO (najstaršie nároky prvé) a prenáša sa ďalej. <strong>Vek dlhu</strong> = vek najstaršieho nevyčerpaného NV; lehota na poskytnutie je 4–8 mesiacov (§93) – pri ⚠ je prekročená/sa blíži.
      </p>
    </Card>
  );
}
